export default {
  get name(): string {
    return 'ExpoFaceDetector';
  },
};
